export const timeFetchFirebase = 10;

export const ENVIRONMENT = 'environment';
export const USER_NAME = 'user_name';
export const CUSTOM_MESSAGE_POPUP = 'custom_message_popup';
export const SHOW_AREA_FEATURE_TO_CLIENT = 'show_area_feature_to_client';

export const defaultValues = {
  [ENVIRONMENT]: 'stage',
  [USER_NAME]: 'Nubi User',
  [CUSTOM_MESSAGE_POPUP]: JSON.stringify({
    enabled: false,
    title: '¡Nueva funcionalidad disponible!',
    message:
      'Hemos agregado nuevas características a la plataforma que te ayudarán a gestionar mejor tus operaciones.\n\n• Mejoras en la interfaz de usuario\n• Optimizaciones de rendimiento',
    showCloseButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Aceptar',
  }),
  [SHOW_AREA_FEATURE_TO_CLIENT]: false,
};
